import Vue from 'vue';
import Vuetify from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2196f3',
        secondary: '#009688',
        accent: '#f44336',
        error: '#b71c1c',
        icon: '#616161',
      },
    },
    breakpoint: {
      thresholds: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
      },
    },
  },
});
